import React from 'react';
import { Row, Col } from 'reactstrap';
import { Typography, IconButton, ListItem, ListItemAvatar, ListItemText, AppBar, Tooltip } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import './ChatStyle.css'

import AddRoundedIcon from '@material-ui/icons/AddRounded';

import ForumTwoToneIcon from '@material-ui/icons/ForumTwoTone';
import { toKebabCase } from '../../../../helpers/cssHelper';
import { formatTime } from './timehelper';
import SystemLabel from '../../../../system/SystemLabel/SystemLabel';



const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        borderBottom: '1px solid gainsboro'
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    online: {
        background: '#44b700'
    },
    offline: {
        background: 'orangered'
    },
}));

export default class ChatPlaceHolder extends React.Component {

    render() {
        const obj = this.props.template.content.interaction.chat;
        const primaryColor = obj.primaryColor;
        const secondaryColor = obj.secondaryColor;
        const badgePillColor = obj.badgePillColor;
        const sendButtonColor = obj.sendButtonColor;
        const container = obj.container;
        const content = obj.content;
        const messagesStyle = obj.messages;
        const header = obj.header;
        const footer = obj.footer;
        /*    const content = { background: obj.background, borderRadius: obj.borderRadius, borderWidth: obj.borderWidth, borderColor: obj.borderColor };
           const text = { fontFamily: obj.fontFamily, fontWeight: obj.fontWeight, fontSize: obj.fontSize, color: obj.color }; */


        const { template } = this.props;
        const exampleMessages = [
            { fromYou: false, name: 'John Doe' },
            { fromYou: true, name: 'Jimmy Hendrix' }
        ]
        return (

            <div className="chat-container" style={{
                backgroundColor: '#fff',
                border: `1px solid ${template.content.backgroundColor}`,
                borderWidth: container.borderWidth != 'unset' ? container.borderWidth : '1px',
                borderColor: container.borderColor != 'unset' ? container.borderColor : template.content.borderColor,
                borderRadius: container.borderRadius != 'unset' ? container.borderRadius : template.content.borderRadius,
                overflow: 'hidden'
            }}>
                <AppBar
                    position={'static'} style={{
                        width: '100%',
                        background: header.background != 'unset' ? header.background : '#fff',
                        boxShadow: 'none',
                        borderBottom: `1px solid ${header.borderColor != 'unset' ? header.borderColor : 'gainsboro'}`
                    }}>
                    <Row>
                        <Col className="col-7 text-left" style={{ overflow: 'hidden', maxHeight: 61 }}>
                            <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                    <Avatar className="chat-avatar" style={{ background: primaryColor != 'unset' ? primaryColor : '#5a60e3', color: secondaryColor != 'unset' ? secondaryColor : '#fff' }}  >
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText

                                    primary={<div
                                        style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxHeight: '61px',
                                            color: header.color != 'unset' ? header.color : '#222',
                                            fontWeight: header.fontWeight != 'unset' ? header.fontWeight : 'initial',
                                            fontFamily: header.fontFamily != 'unset' ? header.fontFamily : 'Open Sans',
                                            fontSize: header.fontSize != 'unset' ? header.fontSize : '1.8vh',
                                        }}
                                    >
                                        John Doe
                                    </div>
                                    }
                                    secondary={<div style={{
                                        color: header.color != 'unset' ? header.color : '#222',
                                        fontWeight: header.fontWeight != 'unset' ? header.fontWeight : 'initial',
                                        fontFamily: header.fontFamily != 'unset' ? header.fontFamily : 'Open Sans',
                                        fontSize: header.fontSize != 'unset' ? header.fontSize : '1.8vh'
                                    }}>

                                        Big Company
                                        </div>}
                                />
                            </ListItem>
                        </Col>
                        <Col className="col-5 text-right" style={{ paddingTop: 10 }}>
                            <IconButton style={{ color: primaryColor != 'unset' ? primaryColor : '#5a60e3', padding: '4px 8px' }} disabled>
                                <Badge badgeContent={<div style={{
                                    background: badgePillColor != 'unset' ? badgePillColor : '#f50057', padding: '4px 5px',
                                    color: secondaryColor != 'unset' ? secondaryColor : '#fff',
                                    borderRadius: '40%'
                                }}>10</div>}  >
                                    <ForumTwoToneIcon />
                                </Badge>
                            </IconButton>
                            <IconButton style={{ color: primaryColor != 'unset' ? primaryColor : '#5a60e3', padding: '4px 8px' }} disabled >
                                <AddRoundedIcon />
                            </IconButton>
                        </Col>
                    </Row>
                </AppBar>
                <React.Fragment>
                    <div className="styleWrapper"
                        style={
                            { width: "100%", height: 'calc(100% - 117px)' }
                        }>
                        <style>
                            {`${toKebabCase(template.scrollbar, true, true)} `}
                        </style>
                        <div className="conversation jir-scroll" style={{ background: content.background != 'unset' ? content.background : '#fff' }} >
                            {exampleMessages.map((m, i) => {
                                return (
                                    <div ref={i} key={i} className="c-box"  >
                                        <ChatBox
                                            size={1}
                                            message={"Hej!"}
                                            id={i}
                                            timeStamp={new Date()}
                                            name={m.name}
                                            last={false}
                                            first={true}
                                            likes={0}
                                            onLike={() => null}
                                            fromYou={m.fromYou}
                                            lang={'swe'}
                                            style={messagesStyle}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="text-bar" style={{
                        background: footer.background != 'unset' ? footer.background : '#fff',
                        borderTop: `1px solid ${footer.borderColor != 'unset' ? footer.borderColor : 'gainsboro'}`

                    }}>
                        <div className="text-bar__field" >
                            <input
                                style={{
                                    background: footer.inputBackground != 'unset' ? footer.inputBackground : '#fff',
                                    color: footer.inputColor != 'unset' ? footer.inputColor : 'initial',
                                    fontFamily: footer.fontFamily != 'unset' ? footer.fontFamily : 'Open Sans',
                                }}
                                className="chat-input" type="text" value="Hur mår du?"
                                onChange={(e) => null} />
                        </div>
                        <div className="text-bar__thumb">

                            <IconButton disabled style={{ color: sendButtonColor != 'unset' ? sendButtonColor : 'inital' }} >
                                <SendIcon />
                            </IconButton>
                            <IconButton disabled style={{ color: primaryColor != 'unset' ? primaryColor : '#5a60e3' }} >
                                <ThumbUpIcon />
                            </IconButton>
                        </div>
                    </div>
                </React.Fragment>
            </div>
        )
    }
}



export function ChatBox({ message = '', id, timeStamp, name, size, onLike, likes = 0, clientKey = null, fromYou = false, last = false, first = false, lang = 'swe', style = null }) {
    return (
        <div style={{ width: '100%' }}>
            {first ? <Row style={{ width: '100%', margin: 0 }}>
                <Col className={fromYou ? 'messages messages--sent' : 'messages messages--received'} >
                    <div
                        style={{ color: style.color != 'unset' ? style.color : 'initial', }}
                        className={"time-stamp" + (size == 2 ? ' xl' : '')}
                        /* style={{
                            paddingLeft: !fromYou ? '13px' : undefined,
                            paddingRight: fromYou ? '13px' : undefined

                        }} */>
                        <strong>{fromYou ? (first ? <SystemLabel name="Me" languageCode={lang} /> : '') : (!name || name.toString().includes('null') ? <React.Fragment>
                            <SystemLabel name="AnonymousClient" languageCode={lang} />{"_"}
                            {(clientKey ? clientKey.substring(0, 8) : '')}</React.Fragment> : name)}</strong>
                    </div>
                </Col>
            </Row> : null}
            <Row style={{ width: '100%', margin: 0 }} className={fromYou ? 'messages--sent--wrapper ' : 'messages--received--wrapper'}>
                <Col
                    style={{

                        display: 'flex', justifyContent: fromYou ? 'flex-end' : 'flex-start'
                    }}
                    className={fromYou ? (message.toString().includes('*!') ? 'messages messages--sent yell' : 'messages messages--sent') :
                        (message.toString().includes('*!') ? 'messages messages--received yell' : 'messages messages--received')} >

                    {/*   {!fromYou && last ? <div style={{ marginRight: '10px', position: 'relative' }}>
                        <Avatar className="chat-avatar" style={{ position: 'absolute', bottom: '-5px', left: '-28px' }} />
                    </div> : <div style={{ marginRight: '20px' }} />} */}

                    {message.toString() == 'THUMB_UP' ?
                        <div style={{ position: 'relative' }} className={"thumb" + (size == 2 ? ' xl' : '')}>  <ThumbUpIcon /></div>
                        : <div style={{
                            fontFamily: style.fontFamily != 'unset' ? style.fontFamily : 'Open Sans',
                            lineHeight: style.lineHeight != 'unset' ? style.lineHeight : 'auto',
                            fontSize: style.fontSize != 'unset' ? style.fontSize : '15px',
                            color: fromYou ?
                                (style.sender.color != 'unset' ? style.sender.color : 'inital') :
                                (style.receiver.color != 'unset' ? style.receiver.color : 'inital'),
                            background: fromYou ?
                                (style.sender.backgroundColor != 'unset' ? style.sender.backgroundColor : 'inital') :
                                (style.receiver.backgroundColor != 'unset' ? style.receiver.backgroundColor : 'inital')

                        }} className={"message" + (size == 2 ? ' xl' : '')}>
                            {message.toString().replace('*!', '')}
                            {likes > 0 ? <div className="liked-message-box"><ThumbUpIcon /> {" "} {likes}</div> : null}
                        </div>}

                    {message.toString() != 'THUMB_UP' ? <div className="like-tools" onClick={() => onLike(id)}>
                        <ThumbUpIcon /> {" "}<SystemLabel name="Like" languageCode={lang} />
                    </div> : null}

                    {/* {fromYou && last ? <div style={{ marginLeft: '20px', position: 'relative' }}>
                        <Avatar className="chat-avatar" style={{ position: 'absolute', bottom: '-5px', left: '-12px' }} />
                    </div> : <div style={{ marginLeft: '20px' }} />} */}
                </Col>
            </Row>
            {timeStamp ? <Row style={{ width: '100%', margin: 0, marginTop: '-11px' }}>
                <Col className={fromYou ? 'messages messages--sent' : 'messages messages--received'} >
                    <div
                        className={"time-stamp" + (size == 2 ? ' xl' : '')}
                        /* style={{
                            paddingLeft: !fromYou ? '13px' : undefined,
                            paddingRight: fromYou ? '13px' : undefined

                        }} */>
                        {timeStamp ? formatTime(timeStamp, lang) : ''}
                    </div>
                </Col>
            </Row> : null}
        </div >
    )
}

